module.exports = __webpack_public_path__ + "img/qrcode.3f09820d.png";